import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToOwnerService,
  mapApiResourceToService,
  mapServiceWritePayload,
  type OwnerService,
  type OwnerServiceApiResource,
  type Service,
  type ServiceApiResource,
  type ServiceWritePayload,
} from './servicesApi.types';

export async function fetchServices(
  search: string,
  includeInactive: boolean
): Promise<Service[]> {
  const trimmed = search.trim();
  const response = await httpClient.get<ServiceApiResource[]>('/services', {
    params: {
      search: trimmed.length === 0 ? undefined : trimmed,
      include_inactive: includeInactive ? true : undefined,
    },
  });
  return response.data.map(mapApiResourceToService);
}

export async function createService(payload: ServiceWritePayload): Promise<Service> {
  const response = await httpClient.post<ServiceApiResource>(
    '/services',
    mapServiceWritePayload(payload)
  );
  return mapApiResourceToService(response.data);
}

export async function updateService(
  serviceId: string,
  payload: ServiceWritePayload
): Promise<Service> {
  const response = await httpClient.patch<ServiceApiResource>(
    '/services/' + serviceId,
    mapServiceWritePayload(payload)
  );
  return mapApiResourceToService(response.data);
}

export async function setServiceActive(serviceId: string, isActive: boolean): Promise<Service> {
  const action = isActive ? 'activate' : 'deactivate';
  const response = await httpClient.post<ServiceApiResource>(
    '/services/' + serviceId + '/' + action
  );
  return mapApiResourceToService(response.data);
}

export async function fetchOwnServices(): Promise<OwnerService[]> {
  const response = await httpClient.get<OwnerServiceApiResource[]>('/me/services');
  return response.data.map(mapApiResourceToOwnerService);
}
